import asFloat from './asFloat'
import asString from './asString'
import convertOr from './convertOr'
import asPrimaryKey from './asPrimaryKey'
import asList from './asList'
import asDateTime from './asDateTime'
import asTimeStamp from './asTimeStamp'
import asObject from './asObject'
import asNull from './asNull'
import asInt from './asInt'
import asArray from './asArray'
import asJson from './asJson'

function determineOr (maybeOrOptions: ?any, maybeOptions: ?any): any {
  if (maybeOrOptions != null && typeof maybeOrOptions === 'object' && maybeOrOptions.or != null) {
    return maybeOrOptions.or
  } else if (maybeOptions != null && typeof maybeOptions === 'object' && maybeOptions.or != null) {
    return maybeOptions.or
  }

  return maybeOrOptions != null
    ? (maybeOrOptions != null && typeof maybeOrOptions !== 'object' ? maybeOrOptions : null)
    : null
}

function determineOptions (maybeOrOptions: ?any, maybeOptions: ?any): { or: any } {
  if (maybeOptions != null) {
    return {
      ...maybeOptions,
      or: determineOr(maybeOrOptions, maybeOptions),
    }
  } else if (typeof maybeOrOptions === 'object') {
    return {
      ...maybeOrOptions,
      or: determineOr(maybeOrOptions, maybeOptions),
    }
  }

  return {
    or: determineOr(maybeOrOptions, maybeOptions),
  }
}

export default function (type: ?string, maybeOrOptions: ?any, maybeOptions: ?any): (value: ?any) => any {
  const options = determineOptions(maybeOrOptions, maybeOptions)
  const or = options.or
  const config = {
    or,
    options: [],
    format: 'DD-MM-YYYY:HH:mm:ss',
    precision: 2,
    ...options,
  }

  switch (type) {
    case 'boolean':
      return convertOr(Boolean, or)
    case 'number':
      return convertOr(Number, or)
    case 'integer':
      return convertOr(asInt, or)
    case 'float':
      return convertOr(asFloat(config.precision), or)
    case 'string':
      return convertOr(asString, or)
    case 'pk':
      return convertOr(asPrimaryKey, or)
    case 'list':
      let list = config.options
      if (!(list instanceof Array)) {
        if (typeof list === 'object') {
          list = Object.keys(list)
        } else {
          list = []
        }
      }

      return asList(list, config.or)
    case 'datetime':
    case 'date':
    case 'time':
      return convertOr(asDateTime.bind(null, config.format), config.or)
    case 'timestamp':
      return convertOr(asTimeStamp(config.format), config.or)
    case 'object':
      return convertOr(asObject, or)
    case 'array':
      return convertOr(asArray, or)
    case 'json':
      return convertOr(asJson, or)
    default:
      return convertOr(asNull, or)
  }
}
